/* aiQuote.js — cliente del endpoint Peicar AI (Fase 4).
 * POST api/v1/ai/quote-suggest → intención estructurada del usuario.
 * La resolución contra el catálogo RODAC (marca/modelo/versión reales) la hace
 * useHeroQuote.aiSuggestReal; si esto falla, el hero cae al mock de heroCore.
 */
import axios from 'axios';
import { api } from '../../../env';

/**
 * @param {string} prompt descripción natural del usuario
 * @param {string[]} brands marcas RODAC disponibles (grounding del LLM)
 * @returns {Promise<object>} suggestion: {marca, modelo, year, version_pref,
 *   carroceria, motor, plan, plazo, engPct, precio_estimado, budget, razon}
 */
export async function fetchAiSuggestion(prompt, brands = []) {
  const res = await axios.post(
    `${api}/v1/ai/quote-suggest`,
    { prompt, brands },
    { timeout: 45000 }
  );
  const suggestion = res.data?.suggestion;
  if (!suggestion?.marca || !suggestion?.modelo) {
    throw new Error('Respuesta de IA inválida');
  }
  return suggestion;
}

/**
 * Precio de mercado REAL del auto YA resuelto (con el AÑO real del catálogo, que
 * puede diferir del que propuso el LLM). Lo resuelve el backend con OpenAI web
 * search y lo cachea por auto+año. Mejor base para la renta que el estimado del
 * LLM; si tarda/falla, devolvemos null y el llamador cae al estimado.
 * @returns {Promise<number|null>} precio MXN o null
 */
export async function fetchCarPrice({ marca, modelo, year, condicion }) {
  try {
    const res = await axios.post(
      `${api}/v1/ai/price-lookup`,
      { marca, modelo, year, condicion },
      { timeout: 12000 }
    );
    const price = +res.data?.price || 0;
    return price > 0 ? price : null;
  } catch (_) {
    return null; // best-effort: el hero usa el precio_estimado del LLM
  }
}
